import { styled } from '@mui/system';
import { Datagrid } from 'react-admin';
import globalStyles from '../../utils/globalStyles'

const MyDatagrid = styled(Datagrid)({
    backgroundColor: globalStyles.colors.white,
    "& .RaDatagrid-headerCell": {
        backgroundColor: globalStyles.colors.backgroundPrimary,
        color: globalStyles.colors.white,
        //padding: '10px 5px',
        width: 'max-content',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        height: '10px',
        borderRadius: '0px !important',
        margin: '10px 5px',
        border: '2px solid #fff !important',
        '&:hover': {
          color: '#fff !important'
        }
    },
    "& .MuiTableSortLabel-root": {
      color: globalStyles.colors.white
    },
    "& .MuiCheckbox-root": {
      color: globalStyles.colors.white
    },
    "& .RaDatagrid-checkbox": {
      color: globalStyles.colors.black
    },
    "& .RaDatagrid-rowCell": {
      textAlign: 'center'
    },
    "& .MuiTableSortLabel-root.Mui-active": {
      color: '#fff !important',
      textAlign: 'center'
    },
    "& .Mui-active .MuiTableSortLabel-icon": {
      display: 'none !important'
    },
    "& .RaDatagrid-checkbox": {
      color: '#cccccc'
    },
    "& .RaSidebarToggleButton-root": {
      display: 'none !important'
    }
});

export default MyDatagrid
